var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-5 py-2"},[_c('div',{staticClass:"text-xs font-normal leading-6 uppercase"},[_vm._v(_vm._s(_vm.item.name))]),_c('div',{staticClass:"text-sm font-medium leading-6"},[_vm._v(" "+_vm._s(_vm.item.address)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }